
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const ho010 = {
    label: "Dictionary",
    pageLabel: "Dictionary",
    starting: true,
    url: "ho010",
    pageType: "history",
    form: [
        {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Only Blank Marathi",
            name: "OnlyBlankMarathi",
            description: "Only Blank Marathi"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "English Name",
            name: "",
            description: "Enter English Name"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "English Name",
            name: "English_Name",
            description: "Enter English Name"
          },
        {
            inputType: "handsonTable",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            // headers:["Car", "Model", "Number", "Date"],
            // data:[],
            label: "",
            name: "productdemandpriority",
            description: "none",
            tableOptions: {
              // validations, basic calculations, colors, date pickers, context menu etc.
              HOTheaders: [
                "English",
                "Marathi"
              ],
              columns: [
                {},
                {},
                ],
              rowHeaders: false,
              // contextMenu: true,
              minSpareRows: 4,
              stretchH: "last",
              // columnSorting: true,
              autoWrapRow: true,
              maxRows: 100,
            
            }
          },
    ]
}

export default ho010;